/* eslint-disable @typescript-eslint/no-explicit-any */
import { ArrowForwardIos, Search } from "@material-ui/icons";
import Card from "components/UI/Card/Card";
import CardBody from "components/UI/Card/CardBody";
import CardHeader from "components/UI/Card/CardHeader";
import CardIcon from "components/UI/Card/CardIcon";
import ReactTable from "components/Tables/ReactTable/ReactTable";
import { makeStyles } from "@material-ui/core/styles";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";
import { CircularProgress } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import ButtonTS from "components/Forms/CustomButtons/ButtonTS";
import { useNavigate } from "react-router-dom";
import { getBadgeFromStatus } from "utils/functions";
import GridItemTS from "components/UI/Grid/GridItemTS";
import GridContainer from "components/UI/Grid/GridContainer";
import { customFilter } from "helpers/customFilter";

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px",
  },
};

const useStyles = makeStyles(styles as any);

type WorkersTableProps = {
  data: any[];
  omit?: string[];
  initialPageSize?: number;
  isLoading?: boolean;
};

export default function WorkersRelatedTable({
  data,
  omit = [],
  initialPageSize = 20,
  isLoading = true,
}: WorkersTableProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { t } = useTranslation("sow-table");

  const statusFilterOptions = {
    enum: {
      CLOSED: "CLOSED",
      PENDING: "PENDING",
      ACTIVE: "ACTIVE",
      INACTIVE: "INACTIVE",
    },
    status: ["ACTIVE", "PENDING", "CLOSED", "INACTIVE"],
  };

  const columns = [
    {
      Header: t("status"),
      accessor: "status",
      filter: customFilter,
      statusFilterOptions: statusFilterOptions,
    },
    {
      Header: "ID",
      accessor: "workerID",
    },
    {
      Header: t("name"),
      accessor: "firstName",
    },
    {
      Header: t("Email"),
      accessor: "workerEmail",
    },
    {
      Header: t("vendorName"),
      accessor: "vendorName",
    },
    {
      Header: t("vendorNumber"),
      accessor: "vendorNumber",
    },
    {
      Header: t("actions"),
      accessor: "actions",
    },
  ];

  const columnsFiltered = columns.filter(
    (column) => !omit.includes(column.accessor),
  );

  const dataFormatted =
    data?.map((worker) => {
      return {
        ...worker,
        status: getBadgeFromStatus(worker?.status, (text: string) =>
          t(text, { ns: "status" }),
        ),
        actions: (
          <div className="actions-right">
            <ButtonTS
              justIcon
              round
              color="info"
              size="sm"
              onClick={() =>
                navigate(`/app/workers/profile?id=${worker?.workerID}`)
              }
            >
              <ArrowForwardIos />
            </ButtonTS>
          </div>
        ),
      };
    }) || [];

  return (
    <GridContainer>
      <GridItemTS key="work-related-table-grid" xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Search />
            </CardIcon>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-end",
              }}
            >
              <h4
                className={classes.cardIconTitle}
                data-cy="workers-related-title"
              >
                {t("Workers Related", { ns: "profile" })}
              </h4>
            </div>
          </CardHeader>
          <CardBody>
            {isLoading ? (
              <CircularProgress data-cy="loading-indicator" />
            ) : (
              <ReactTable
                columns={columnsFiltered}
                data={dataFormatted}
                initialPageSize={initialPageSize}
                id="workers-related-table"
                columnsNotTrimFilters={["firstName", "vendorName"]}
                statusFilterOptions={statusFilterOptions}
              />
            )}
          </CardBody>
        </Card>
      </GridItemTS>
    </GridContainer>
  );
}
